<template>
  <v-chip
    v-bind="data.attrs"
    :input-value="data.selected"
    close
    @click="data.select"
    @click:close="$emit('remove')"
  >
    <StatusAvatar :user="data.item" avatar-size="24px" badge-size="8px"/>
    <span class="ml-3">{{ data.item.name }}</span>
  </v-chip>
</template>

<script>
import StatusAvatar from '@/components/buddies/status_avatar'
export default {
  components: { StatusAvatar },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style>

</style>
